"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Input = _interopRequireDefault(require("./Input"));

var _PostTreeSelect = _interopRequireDefault(require("./PostTreeSelect"));

var _utils = require("../utils");

var _store = require("../store");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LinkSelector = function LinkSelector(props) {
  var _sites$siteID;

  var _props$value = props.value,
      value = _props$value === void 0 ? {} : _props$value,
      placeholder = props.placeholder,
      onChange = props.onChange,
      removable = props.removable;

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$0$cmsState = _ref2[0].cmsState,
      sites = _ref2$0$cmsState.sites,
      siteID = _ref2$0$cmsState.siteID,
      dispatch = _ref2[1];

  var _ref3 = (0, _react.useState)(''),
      _ref4 = _slicedToArray(_ref3, 2),
      post = _ref4[0],
      setPost = _ref4[1];

  var _ref5 = (0, _react.useState)(value),
      _ref6 = _slicedToArray(_ref5, 2),
      link = _ref6[0],
      setLink = _ref6[1];

  var allPosts = [];
  Object.values((_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : _sites$siteID.postTypes).map(function (o) {
    Object.values(o.posts).map(function (p) {
      return allPosts.push(_objectSpread(_objectSpread({}, p), {}, {
        caption: o.title
      }));
    });
  });

  var handleChange = function handleChange(name, newValue) {
    setLink(_objectSpread(_objectSpread({}, link), {}, _defineProperty({}, name, newValue)));
  };

  var handleSubmit = function handleSubmit() {
    onChange(link);
    setLink({
      title: '',
      url: '',
      target: ''
    });
    dispatch({
      type: "CLOSE_DIALOG"
    });
  };

  var handleRemove = function handleRemove() {
    onChange({
      title: link.title,
      url: '',
      target: ''
    });
    setLink({
      title: '',
      url: '',
      target: ''
    });
    dispatch({
      type: "CLOSE_DIALOG"
    });
  };

  var handleTreeSelect = function handleTreeSelect(id) {
    if (id) {
      var _sites$siteID2, _sites$siteID3;

      setPost(id);

      var _post = allPosts.find(function (o) {
        return o.id === id;
      });

      var postType = Object.values((_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : _sites$siteID2.postTypes).find(function (o) {
        return o.id === _post.postTypeID;
      });
      setLink({
        title: link.title || _post.title,
        url: (0, _utils.generateSlug)(postType, _post.id, (_sites$siteID3 = sites[siteID]) === null || _sites$siteID3 === void 0 ? void 0 : _sites$siteID3.frontPage, true),
        target: false
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_PostTreeSelect.default, {
    label: "Select Post",
    items: allPosts,
    value: post,
    onChange: handleTreeSelect
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Link",
    value: (link === null || link === void 0 ? void 0 : link.url) || '',
    placeholder: 'https://',
    onChange: function onChange(e) {
      return handleChange('url', e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Text",
    value: (link === null || link === void 0 ? void 0 : link.title) || '',
    placeholder: placeholder || 'Text',
    onChange: function onChange(e) {
      return handleChange('title', e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
    value: '_blank',
    checked: (link === null || link === void 0 ? void 0 : link.target) || false,
    onChange: function onChange(e) {
      return handleChange('target', e.target.checked ? e.target.value : '');
    },
    children: "Open in new tab"
  }), /*#__PURE__*/_react.default.createElement(_antd.Space, null, removable && /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: 'Remove',
    onClick: handleRemove,
    danger: true
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: 'Update',
    onClick: handleSubmit,
    type: "primary"
  }))));
};

var _default = LinkSelector;
exports.default = _default;